export default {
  EXPRESS: {
    value: 1,
    label: '快递',
  },

  /*SELF_PICKUP: {
    value: 2,
    label: '自提',
  },*/
}
